module.exports = __webpack_public_path__ + "static/media/reliable.8eafa821.jpg";